import React from 'react';
import { PhoneImage } from '../../../../../assets/images';
import { ImageTextLink } from '../../imageTextLink';
import { PhoneUtility } from '@mchs/web-core';
import { TextLink } from '../../textLink';
import { ImageAlignment } from '../../../../../models';

interface PhoneLinkProps {
  phoneNumber: string;
  includeImage?: boolean;
}

const PhoneLink: React.FC<PhoneLinkProps> = (props: PhoneLinkProps) => {
  const onPhoneClicked = () => {
    PhoneUtility.callPhone(props.phoneNumber);
  };

  return (
    <>
      {props.includeImage === undefined || props.includeImage ? (
        <ImageTextLink
          imageSource={PhoneImage}
          caption={PhoneUtility.formatPhoneNumber(props.phoneNumber)}
          onClick={onPhoneClicked}
          imageAlignment={ImageAlignment.Left}
          allowWrap={false}
        />
      ) : (
        <TextLink
          caption={PhoneUtility.formatPhoneNumber(props.phoneNumber)}
          onClick={onPhoneClicked}
          allowWrap={false}
        />
      )}
    </>
  );
};

export default PhoneLink;
